import { getStore } from '~/mobx/AppStore';

export const getIsShowed = () => {
    const {
        candidateStore,
        generalSettingsStore,
        loginPageStore,
        userStore,
        regionPreviewStore,
        regionStore,
        adminStore,
        companyStore,
        zipcodeStore,
        adminReportStore,
        reportStore,
    } = getStore();

    if (!userStore.isInitialized) {
        return true;
    }

    if (regionStore.getIsLoading()) {
        return true;
    }

    if (regionPreviewStore.isDownloadingRegionPreview || regionPreviewStore.isChangingRegion) {
        return true;
    }

    if (loginPageStore.isLoggingIn || loginPageStore.isRedirecting) {
        return true;
    }

    if (userStore.isLoggingOut) {
        return true;
    }

    if (candidateStore.getIsLoading()) {
        return true;
    }

    if (generalSettingsStore.getIsLoading()) {
        return true;
    }

    if (adminStore.getIsLoading()) {
        return true;
    }

    if (candidateStore.isUploadingCandidatePhoto) {
        return true;
    }

    if (companyStore.isGettingCompanyList) {
        return true;
    }

    if (zipcodeStore.isGettingZipcode) {
        return true;
    }

    if (adminReportStore.getIsLoading()) {
        return true;
    }

    if (reportStore.getIsLoading()) {
        return true;
    }

    return false;
};
